import { z, ZodIssueCode, type ZodErrorMap } from 'zod';

/** Mensajes de validación en español para los esquemas de @tarja/contracts (misma instancia de zod). */
export const mapaErroresEs: ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === 'undefined' || issue.received === 'null') return { message: 'Campo obligatorio' };
      if (issue.expected === 'number') return { message: 'Debe ser un número' };
      if (issue.expected === 'object') return { message: 'Formato inválido (se espera un objeto JSON)' };
      if (issue.expected === 'array') return { message: 'Se espera una lista' };
      return { message: 'Valor inválido' };
    case ZodIssueCode.too_small:
      if (issue.type === 'string') return { message: issue.minimum === 1 ? 'Campo obligatorio' : `Mínimo ${String(issue.minimum)} caracteres` };
      if (issue.type === 'array') return { message: `Agrega al menos ${String(issue.minimum)} elemento(s)` };
      return { message: `Debe ser ${issue.inclusive ? 'mayor o igual a' : 'mayor que'} ${String(issue.minimum)}` };
    case ZodIssueCode.too_big:
      if (issue.type === 'string') return { message: `Máximo ${String(issue.maximum)} caracteres` };
      return { message: `Debe ser ${issue.inclusive ? 'menor o igual a' : 'menor que'} ${String(issue.maximum)}` };
    case ZodIssueCode.invalid_string:
      if (issue.validation === 'uuid') return { message: 'Selecciona un valor válido' };
      if (issue.validation === 'date') return { message: 'Fecha inválida (aaaa-mm-dd)' };
      if (issue.validation === 'datetime') return { message: 'Fecha y hora inválidas' };
      if (issue.validation === 'regex') return { message: issue.message ?? 'Formato inválido' };
      return { message: 'Formato inválido' };
    case ZodIssueCode.invalid_enum_value:
      return { message: 'Selecciona una opción válida' };
    case ZodIssueCode.invalid_union_discriminator:
      return { message: 'Selecciona una opción válida' };
    case ZodIssueCode.not_multiple_of:
      return { message: 'Valor no permitido' };
    case ZodIssueCode.custom:
      return { message: issue.message ?? ctx.defaultError };
    default:
      return { message: ctx.defaultError };
  }
};

export function instalarMensajesZod(): void {
  z.setErrorMap(mapaErroresEs);
}
